<template lang='pug'>
  v-container.px-3.returns-container(fluid)
    v-dialog( :fullscreen="isMobile" width="500" persistent :value='detailsDialog' transition="dialog-bottom-transition")
      Details(v-if='detailsDialog' :request='currentRequest' @close ='detailsDialog=false' admin="return" @showProduct='productDialog = true')
    v-dialog( persistent  :value='showBillDialog'  max-width='600px'   transition="dialog-bottom-transition")
      div(style ='position:relative; height: 100%;')
        bill-preview(@close="showBillDialog=false" @showSupportImage='showSupportImage' @showProduct='productDialog = true' :item="currentTransaction" :currentType='currentType' )
    v-dialog( persistent  :value='purchaseDialog'  max-width='800px'   transition="dialog-bottom-transition" )
      PurchaseForm(v-if='purchaseDialog' @close="purchaseDialog = false")
    v-dialog( persistent  :value='transferDialog'  max-width='800px'   transition="dialog-bottom-transition" )
      TransferForm(v-if='transferDialog' @close="transferDialog = false")
    v-dialog(:fullscreen='isMobile' persistent :key='currentItem.name' :value='productDialog'  max-width='800px'   transition="dialog-bottom-transition")
      Preview(v-if='productDialog' :model ='currentItem' @close='productDialog=false')
    //- Content
    v-row.px-3.justify-space-between.align-center.my-0
      v-col.d-flex.justify-end(cols="12")
        //- Update btn
        v-btn.main-btn-gradient(small style="height: 48px;" @click="fetch()")
          v-icon mdi-refresh
        //- Date filter
        v-menu(v-model='menu', :close-on-content-click='false', :nudge-width='200', nudge-top offset-x='')
          template(v-slot:activator='{ on }')
            v-btn.main-btn-gradient(small color='#3cbbc2', dark='', v-on='on' style="height: 48px;").mt-0
              v-icon mdi-calendar
              | {{$t('returns.dates')}}
          v-card(style="border:3px solid #3cbbc2;").pa-2
            date-filter(@closeMenu="menu = false; loading = true" :currentType= 'currentType',)
    v-row.px-5.my-0
      MovementTransactions(
        title="Movimientos devoluciones"
        :movements="transactions.length.toString() || '0'"
        :total="transactionTotals.total.toFixed(2)"
        utility=""
      )
    v-row.px-5.my-0
      v-card.rounded-lg.pa-3( width="100%")
        v-row
          v-col.pb-0(cols="6" xs="6" sm="6" md="4")
            v-select.rounded-xl(
              :label="$t('returns.filter_by_store')",
              elevation=0
              outlined
              :items='field.locations || []',
              v-model='currentLocation',
              item-text='full_name',
              return-object, dense='', solo='',
              clearable='', @input='selectShop',
              @click:clear='clearShopSelection')
                template(v-if='data.item' slot='selection', slot-scope='data')
                  v-flex(xs2='')
                    v-avatar(size='25px')
                      img( v-if='!!data.item' width='25' style='object-fit:cover;' :src='data.item.pictures.imageInput1')
                  v-flex.ml-1(style='font-size:10px; color :#000;')
                    | {{ data.item.name }}
                template(v-if='data.item' slot='item', slot-scope='data' )
                  v-row.my-1
                    v-avatar
                      img(v-if='!!data.item' width='25' style='object-fit:cover;' :src='data.item.pictures.imageInput1')
                    b {{data.item.name}}
        v-row
          v-col(cols='12' md='12')
            .card-transactions
              v-progress-linear(v-if="loading" indeterminate color="#008e95")
              .show-table-desktop
                v-data-table.elevation-0(:headers="headers" :items="transactions || []"  item-key="name" :search="search")
                  //- template(v-slot:top="")
                    v-toolbar(flat="" color="white")
                      v-toolbar-title {{$t('returns.title_table')}}
                      .flex-grow-1
                  template( v-slot:item="props" )
                    tr(@click="props.item.products ? openDetail(props.item) : '' " :style="props.item.products ? 'cursor: pointer;' : ''")
                      td.text-xs-left
                        .datatable-cell-wrapper {{ props.item.reference_number }}
                      td.text-xs-left(hidden)
                        | {{props.item.items}}
                      td.text-xs-left(style="max-width:250px;")
                        span.mr-1 {{productsInOrder(props.item.products)}}
                      td.text-xs-left
                        .datatable-cell-wrapper  {{ props.item.time | moment}} {{props.item.time | momentHours}}
                      td.text-xs-left
                        .datatable-cell-wrapper {{ props.item.description}}
                      td.text-xs-left
                        .datatable-cell-wrapper(v-if="props.item.status === 'pending'  && props.item.products") {{$t('returns.states.pending')}}
                        .datatable-cell-wrapper(v-if="props.item.status === 'approved' && props.item.products") {{$t('returns.states.approved')}}
                        .datatable-cell-wrapper(v-if="props.item.status === 'rejected' || !props.item.products") {{$t('returns.states.rejected')}}
                      td.text-xs-left()
                        .datatable-cell-wrapper {{props.item.shop.name}}
                      td.text-xs-left(v-if="props.item.type !=='transfers'")
                        .datatable-cell-wrapper {{ props.item.total | numberFormat}}
                      td.text-xs-left(:style='getStatus(props.item.products) === "completed" ? "color: green":"color: #fb8c00"')
                        .datatable-cell-wrapper  {{getStatus(props.item.products) | translateStatus}}
              v-list.show-table-mobile(two-line="" v-if="filteredTransactions.length > 0")
                v-list-item-group(style="width: 100%;")
                  template(v-for="(item, index) in filteredTransactions.slice(10*(page-1), 10*(page))")
                    v-list-item(:key="item.reference_number").notification
                        template(v-slot:default="{ active, toggle }")
                            v-list-item-content(@click="item.products ? openDetail(item) : '' ")
                                p.font-weight-bold # {{item.reference_number}}
                                p.mt-2 {{item.shop.name}}
                                p.mt-2 {{ item.description}}
                                p.mt-2(v-if="item.status === 'pending' && item.products") {{$t('returns.states.pending')}}
                                p.mt-2(v-if="item.status === 'approved' && item.products") {{$t('returns.states.approved')}}
                                p.mt-2(v-if="item.status === 'rejected' || !item.products") {{$t('returns.states.rejected')}}
                                p.mt-2.notification__date {{item.time | moment}} {{item.time | momentHours}}
                                p.mt-2 {{getStatus(item.products) | translateStatus}}
                                p(v-if="item.type !=='transfers'").mt-2.font-weight-bold.notification__price {{ item.total | numberFormat}}
                        v-divider(v-if="index + 1 < filteredTransactions.length" :key="index")
                  v-pagination.my-4(v-model="page" :length="pageNumber")
              .show-table-mobile(v-else)
                NoResults(title="No tienes devoluciones", description="Puedes ver tus devoluciones en otro rango de fechas")
    //- Old content
    //- v-layout(wrap='')
      v-flex(md12='' :style="isMobile ? 'padding-left: 20px !important; padding-right: 20px !important;': ''")
        // v-btn(color="#009da5" fab small dark="" v-if="isMobile" @click="$router.go(-1)").mt-2.ml-5
          v-icon(size="25") mdi-arrow-left
        v-col(v-if="isMobile" cols="12" style="position: relative;")
          v-icon(style="z-index: 10; position: absolute; left: 0; top: 0;" size="65" color="#30b5bb" @click="$router.go(-1)") mdi-chevron-left
          h2.returns__title.returns__underline Devoluciones
        v-card(v-if="!isMobile")
          v-card-title {{$t('returns.title')}}
          .text-center(style="display:flex; align-items:flex-start;margin-left: 25px !important").mt-2
            //- v-menu(v-model='menu', :close-on-content-click='false', :nudge-width='200', nudge-top offset-x='')
              template(v-slot:activator='{ on }')
                v-btn(color='#3cbbc2', dark='', v-on='on' style="height: 48px;").mt-0
                  v-icon mdi-calendar
                  | {{$t('returns.dates')}}
              v-card(style="border:3px solid #3cbbc2;").pa-2
                date-filter(@closeMenu="menu = false; loading = true" :currentType= 'currentType',)
            .text-center(style="display:flex; align-items:center;")
              v-select.elevation-0(
              :label="$t('returns.filter_by_store')",
              :items='field.locations || []',
              v-model='currentLocation',
              item-text='full_name',
              return-object, dense='', solo='',
              clearable='', @input='selectShop',
              @click:clear='clearShopSelection')
                template(v-if='data.item' slot='selection', slot-scope='data')
                  v-flex(xs2='')
                    v-avatar(size='25px')
                      img( v-if='!!data.item' width='25' style='object-fit:cover;' :src='data.item.pictures.imageInput1')
                  v-flex.ml-1(style='font-size:10px; color :#000;')
                    | {{ data.item.name }}
                template(v-if='data.item' slot='item', slot-scope='data' )
                  v-row
                    v-avatar
                      img(v-if='!!data.item' width='25' style='object-fit:cover;' :src='data.item.pictures.imageInput1')
                    b {{data.item.name}}
            //- v-card(style='margin: 2px;' flat link  @click="fetch()" outlined).category-card.py-6.mx-4
              v-layout(pa-1 pl-2).text-center
                v-layout(xs12='' style="z-index: 0;").justify-space-around.align-center
                  span.h2.text-uppercase.text-center.d-flex.justify-center.align-center(style="width: 200px;") Actualizar
                    v-icon mdi-refresh
                    // img.mr-4.ml-2(style='height:36px' :src="updateIcon")
          v-row.pr-5.pl-1(v-if="isMobile")
                    img.mr-4.ml-2(style='height:36px' :src="updateIcon")
          //-
            v-card(v-if="isMobile" style='margin: 2px;' flat link @click="fetch()" height="20" outlined).category-card.py-6.mx-4.mb-8
              v-layout(pa-1 pl-2).text-center
                v-layout(xs12='' style="z-index: 0;").justify-space-around.align-center
                  span.h2.text-uppercase.text-center.d-flex.justify-center.align-center(style="width: 350px;") Actualizar
                    img.mr-4.ml-2(style='height:36px' :src="updateIcon")
          // Cards
          v-layout.bill-action__button-row().my-2
          v-flex(style='display:flex; flex-direction: row; flex-wrap: wrap; justify-content:flex-start; align-items:center;')
            v-flex(sm6='', xs12='', md6='', lg3='')
              base-material-stats-card( v-if ='!!transactions'  color='warning', icon='mdi-swap-vertical', small-value='#' :title="$t('returns.movements')", :value='transactions.length.toString()')
            v-flex(sm6='', xs12='', md6='', lg3='')
              base-material-stats-card( color='cyan', icon='mdi-currency-usd', small-value='$' :title="$t('returns.total')", :value=' transactionTotals.total.toFixed(2) ')
          v-card
            v-progress-linear(v-if="loading" indeterminate color="cyan")
            v-card-title
              v-text-field(v-model='search',@input='setSearchCriteria' append-outer-icon='mdi-search', :label="$t('returns.search')", single-line='', hide-details='')
            v-data-table.elevation-1(:headers="headers" :items="transactions || []"  item-key="name" :search="search")
              template(v-slot:top="")
                v-toolbar(flat="" color="white")
                  v-toolbar-title {{$t('returns.title_table')}}
                  .flex-grow-1
              template( v-slot:item="props" )
                tr(@click="props.item.products ? openDetail(props.item) : '' " :style="props.item.products ? 'cursor: pointer;' : ''")
                  td.text-xs-left
                    .datatable-cell-wrapper {{ props.item.reference_number }}
                  td.text-xs-left(hidden)
                    | {{props.item.items}}
                  td.text-xs-left(style="max-width:250px;")
                    span.mr-1 {{productsInOrder(props.item.products)}}
                  td.text-xs-left
                    .datatable-cell-wrapper  {{ props.item.time | moment}} {{props.item.time | momentHours}}
                  td.text-xs-left
                    .datatable-cell-wrapper {{ props.item.description}}
                  td.text-xs-left
                    .datatable-cell-wrapper(v-if="props.item.status === 'pending'  && props.item.products") {{$t('returns.states.pending')}}
                    .datatable-cell-wrapper(v-if="props.item.status === 'approved' && props.item.products") {{$t('returns.states.approved')}}
                    .datatable-cell-wrapper(v-if="props.item.status === 'rejected' || !props.item.products") {{$t('returns.states.rejected')}}
                  td.text-xs-left()
                    .datatable-cell-wrapper {{props.item.shop.name}}
                  td.text-xs-left(v-if="props.item.type !=='transfers'")
                    .datatable-cell-wrapper {{ props.item.total | numberFormat}}
                  td.text-xs-left(:style='getStatus(props.item.products) === "completed" ? "color: green":"color: #fb8c00"')
                    .datatable-cell-wrapper  {{getStatus(props.item.products) | translateStatus}}
        v-container(v-else)
          .text-center(style="display:flex; align-items:flex-start;margin-left: 15px !important").mt-2
            .text-center(style="display:flex; align-items:center;")
              v-select.elevation-0.mr-4(
              :label="$t('returns.filter_by_store')",
              :items='field.locations || []',
              v-model='currentLocation',
              item-text='full_name',
              return-object, dense='', solo='',
              clearable='', @input='selectShop',
              @click:clear='clearShopSelection')
                template(v-if='data.item' slot='selection', slot-scope='data')
                  v-flex(xs2='')
                    v-avatar(size='25px')
                      img( v-if='!!data.item' width='25' style='object-fit:cover;' :src='data.item.pictures.imageInput1')
                  v-flex.ml-1(style='font-size:10px; color :#000;')
                    | {{ data.item.name }}
                template(v-if='data.item' slot='item', slot-scope='data' )
                  v-row
                    v-avatar
                      img(v-if='!!data.item' width='25' style='object-fit:cover;' :src='data.item.pictures.imageInput1')
                    b {{data.item.name}}
            v-menu(v-model='menu', :close-on-content-click='false', :nudge-width='200', nudge-top offset-x='')
              template(v-slot:activator='{ on }')
                v-btn(color='#3cbbc2' small dark='', v-on='on' style="height: 38px;").mt-0
                  v-icon mdi-calendar
              v-card(style="border:3px solid #3cbbc2;").pa-2
                date-filter(@closeMenu="menu = false" :currentType= 'currentType',)
          v-row.pr-5.pl-1
            v-col
              v-btn.ma-2.white--text.btn-transaction(style='margin: 2px;' block @click="fetch()")
                | Actualizar
                v-icon(right="" dark="")
                  | mdi-refresh
          //-
            v-card(v-if="isMobile" style='margin: 2px;' flat link @click="fetch()" height="20" outlined).category-card.py-6.mx-4.mb-8
              v-layout(pa-1 pl-2).text-center
                v-layout(xs12='' style="z-index: 0;").justify-space-around.align-center
                  span.h2.text-uppercase.text-center.d-flex.justify-center.align-center(style="width: 350px;") Actualizar
                    img.mr-4.ml-2(style='height:36px' :src="updateIcon")
          // Cards
          v-row.px-2
            v-col(cols="12")
              mobileCard(color='cyan', icon='mdi-currency-usd', valueIcon='$' :title="$t('returns.total')", :value=' transactionTotals.total.toFixed(2) ')
            v-col(cols="12")
              mobileCard(v-if ='!!transactions'  color='warning', icon='mdi-swap-vertical', valueIcon='#' :title="$t('returns.movements')", :value='transactions.length.toString()')
          v-card
            v-progress-linear(v-if="loading" indeterminate color="cyan")
            v-card-title
              v-text-field(v-model='search' @input='setSearchCriteria' outlined prepend-inner-icon="mdi-magnify" placeholder="Buscar por referencia o establecimiento")
            v-flex(md12='' style="max-width: 700px").mx-auto.mt-3
              v-list(two-line="" v-if="filteredTransactions.length > 0")
                  v-list-item-group
                    template(v-for="(item, index) in filteredTransactions.slice(10*(page-1), 10*(page))")
                      v-list-item(:key="item.reference_number").notification
                          template(v-slot:default="{ active, toggle }")
                              v-list-item-content(@click="item.products ? openDetail(item) : '' ")
                                  p.font-weight-bold # {{item.reference_number}}
                                  p.mt-2 {{item.shop.name}}
                                  p.mt-2 {{ item.description}}
                                  p.mt-2(v-if="item.status === 'pending' && item.products") {{$t('returns.states.pending')}}
                                  p.mt-2(v-if="item.status === 'approved' && item.products") {{$t('returns.states.approved')}}
                                  p.mt-2(v-if="item.status === 'rejected' || !item.products") {{$t('returns.states.rejected')}}
                                  p.mt-2.notification__date {{item.time | moment}} {{item.time | momentHours}}
                                  p.mt-2 {{getStatus(item.products) | translateStatus}}
                                  p(v-if="item.type !=='transfers'").mt-2.font-weight-bold.notification__price {{ item.total | numberFormat}}
                          v-divider(v-if="index + 1 < filteredTransactions.length" :key="index")
                    v-pagination.my-4(v-model="page" :length="pageNumber")
              template(v-else)
                NoResults(title="No tienes devoluciones", description="Puedes ver tus devoluciones en otro rango de fechas")

</template>

<script>
  import moment from 'moment'
  import DateFilter from '@/components/custom/filters/DateFilter'
  import PurchaseForm from '@/components/custom/forms/PurchaseForm'
  import TransferForm from '@/components/custom/forms/TransferForm'
  import Preview from '@/components/custom/preview/ProductPreview'
  import BillPreview from '@/components/custom/preview/transactions/ReturnsBillPreview'
  import loaders from '@/plugins/mixins/loaders'
  import updateIcon from '@/assets/icons/home/update.png'
  export default {
    components: {
      BillPreview: BillPreview,
      Preview: Preview,
      PurchaseForm: PurchaseForm,
      TransferForm: TransferForm,
      DateFilter: DateFilter,
      Details: () => import('@/views/marketplace/component/profile/RequestDetails'),
      NoResults: () => import('@/components/custom/NoResults'),
      mobileCard: () => import('@/views/custom/transactions/MobileCard.vue'),
      MovementTransactions: () => import('@/components/custom/transactions/movement_transactions'),
    },
    filters: {
      moment: function (date) {
        return moment(date).format('DD/MM/YYYY')
      },
      momentHours: function (date) {
        return moment(date).format('h:mm:ss a')
      },
      numberFormat (val) {
        if (val) { return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') }
        return '0 '
      },
      translateStatus (value) {
        if (value) {
          switch (value) {
            case 'pending':
              return 'Pendiente'
            case 'completed':
              return 'Completo'
          }
        } else {
          return 'N/A'
        }
      },
    },
    mixins: [loaders],
    data () {
      return {
        loading: false,
        updateIcon,
        currentRequest: '',
        detailsDialog: false,
        page: 1,
        menu: false,
        currentLocation: null,
        select: {},
        currentTransaction: null,
        purchaseDialog: false,
        transferDialog: false,
        showBillDialog: false,
        search: '',
        currentType: '',
        createItemDialog: false,
        productDialog: false,
        headers: [
          {
            sortable: false,
            text: this.$t('returns.table_headers.reference_number'),
            value: 'reference_number',
            align: 'left',

          },
          {
            sortable: true,
            text: this.$t('returns.table_headers.products'),
            value: 'products',
            align: 'left',
          },
          {
            sortable: true,
            text: this.$t('returns.table_headers.time'),
            value: 'time',
            align: 'left',

          },
          {
            sortable: true,
            text: this.$t('returns.table_headers.desc'),
            value: 'description',
            align: 'left',

          },
          {
            sortable: true,
            text: this.$t('returns.table_headers.state'),
            value: 'status',
            align: 'left',

          },
          {
            sortable: false,
            text: this.$t('returns.table_headers.location'),
            value: 'location.name',
            align: 'left',

          },
          {
            sortable: true,
            text: this.$t('returns.table_headers.total'),
            value: 'total',
            align: 'left',

          },
          {
            sortable: true,
            text: this.$t('purchases.table_headers.status'),
            value: 'Estatus productos',
            align: 'left',
          },
          {
            text: '',
            value: 'data-table-expand',
          },
        ],
      }
    },
    computed: {
      isMobile () {
        return window.innerWidth < 1024
      },
      field () {
        return {
          locations: this.$store.getters['shops/getItems'],
          categories: this.$store.getters['categories/getItems'],
        }
      },
      revenue () {
        return this.$store.getters['transactions/getRevenueTotal']
      },
      currentItem () {
        return this.$store.getters['products/getCurrentItem']
      },

      products () {
        return [
          {
            name: 'Todos',
            value: '',
          },
        ]
      },
      returns () {
        // console.log(this.$store.state.transactions.returns)
        return this.$store.state.transactions.returns
      },
      // FILTRO DE TRANSACCIONES NO ESTA FUNCIONANDO CORRECTAMENTE, NO ACTUALIZA LOS DATOS DEPENDIENDO DE LA TIENDA
      transactions () {
        const vm = this
        if (!!vm.currentLocation && !!vm.returns) {
          // console.log('se escogio : ' + vm.currentLocation.name)
          return vm.returns.filter((el) => {
            if (el.location_from.id === vm.currentLocation.id) {
              // console.log(el.location_from.id, vm.currentLocation.id)
              return true
            }
          }).reverse()
        } else if (vm.returns) {
          // console.log('entra en nulo')
          return vm.returns.reverse()
        } else {
          return vm.returns
        }
      },
      transactionTotals () {
        const vm = this
        let total = 0
        let revenue = 0
        // console.log(revenue)
        if (vm.transactions) {
          const list = vm.transactions || {}
          list.forEach(element => {
            // if( Vue.moment().isSame(element.time, state.currentDateFilter))
            total += +element.total
            if (element.items) {
              element.items.forEach(item => {
                if (item.purchase) {
                  revenue += (+item.price - +item.purchase) * +item.amount
                }
              })
            }
          })
          return {
            total: total,
            revenue: revenue,
          }
        }
        return {
          total: 0,
          revenue: 0,
        }
      },
      pageNumber () {
        if (this.isMobile) {
          return Math.ceil(this.filteredTransactions.length / 10)
        } else {
          return Math.ceil(this.transactions.length / 10)
        }
      },
      filteredTransactions () {
        return this.transactions.filter((transaction) => {
          return (transaction.location_from.name.toLowerCase().match(this.search.toLowerCase()) || transaction.reference_number.toString().includes(this.search))
        })
      },
    },
    watch: {
      transactions (val, oldval) {
        // console.log(val, oldval)
        const vm = this
        vm.loading = false
      },
      $route (to, from) {
        // react to route changes...
        if (this.$route.params.type) {
          this.currentType = this.$route.params.type
          // console.log(this.$route.params.type)
        } else this.currentType = 'sales'
      },
    },
    created () {
      this.currentType = this.$route.params.type
      this.fetch(this.currentType)
    },
    beforeDestroy () {
      this.$store.dispatch('transactions/clearTransactions').then(function (res) {
        // console.log('transactions cleared')
      })
      this.clearShopSelection()
    },
    methods: {
      productsInOrder (products) {
        // span(v-for='product in props.item.items') {{product.name}},
        let productsString = ''
        if (products) {
          products.forEach((product, index) => {
            if (index !== products.length - 1) {
              productsString += product.name + ', '
            } else {
              productsString += product.name
            }
          })
        } else {
          return 'Esta devolución no tiene productos'
        }
        if (productsString.length > 50) {
          return productsString.substring(0, 50) + '...'
        } else {
          return productsString
        }
      },
      openDetail (item) {
        const vm = this
        vm.currentRequest = item
        vm.detailsDialog = true
      },
      async showBill (item) {
        this.currentTransaction = await item
        // console.log(item)
        this.showBillDialog = !this.showBillDialog
      },
      showSupportImage (url) {
        this.$swal({
          title: 'Comprobante',
          text: 'Modal with a custom image.',
          // imageUrl: url,
          imageWidth: 400,
          imageHeight: 200,
          imageAlt: 'Custom image',
          html: `
              <a target="_blank" href="${url}" download>
                <img style='max-height: 500px;' src="${url}" alt="comprobante">
              </a>
                    `,
          showConfirmButton: true,
        })
      },
      loadLog (type, dateFrom, dateTo) {
        const vm = this
        vm.$store.dispatch('transactions/loadLog', [type, dateFrom, dateTo, false]).then(function () {
          vm.loading = false
        })
      },
      fetch (type = 'returns') {
        // vm.$store.commit('setLoading',true);
        const vm = this
        vm.loading = true
        const dateFrom = this.$moment().format('YYYY-MM-DD')
        this.loadLog(type, dateFrom, this.$moment(dateFrom).add(1, 'days').format('YYYY-MM-DD'))
      },
      clearShopSelection () {
        const vm = this
        vm.$store.dispatch('shops/setCurrentItem', null).then(function () {
        })
      },
      selectShop (item) {
        const vm = this
        // console.log(item)
        vm.$store.dispatch('shops/setCurrentItem', item).then(function () {
          // console.log(vm.$store.getters['shops/getCurrentItem'])
        })
      },
      setSearchCriteria (val) {
        const vm = this

        vm.$store.dispatch('transactions/setFilterCriteria', val).then(function () {
          //
        })
      },
      setFilterCriteria () {
        const vm = this

        this.$store.dispatch('transactions/setFilterCriteria', vm.select).then(function () {
          //
        })
      },
      getStatus (items) {
        // console.log(items)
        const found = items.find(element => element.status === 'pending')
        // console.log(found)
        if (found) {
          return 'pending'
        } else {
          return 'completed'
        }
      },

    },
  }
</script>

<style lang='scss' scoped>
.returns-container{
  .card-transactions{

    overflow-y: scroll !important;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .show-table-mobile{
    padding-bottom: 50px;
  }
  @media(min-width: 760px) {
    .show-table-mobile{
      display: none !important;
    }
    .show-table-desktop{
      display: block !important;
    }
  }
  @media(max-width: 1100px) {
    .show-table-mobile{
      display: flex !important;
    }
    .show-table-desktop{
      display: none !important;
    }
  }
  .notification{
    display: flex;
    width: 95%;
    margin: 0 auto;
    // border-radius: 10px !important;
    box-shadow: -7px 4px 38px rgba(0, 0, 0, 0.16);
    &__container{
      @media (max-width: 1024px){
        background: transparent;
      }
    }
    &__date{
      font-size: 13px;
      color: #808184;
    }
    &__price{
      color: #35a3a9 !important;
    }
    &__description{
      color: #808184;
      font-size: 18px;
      font-weight: 300;
      line-height: 1.2;
    }
  }
  .returns {
    &__title {
      text-align: center;
      color:#a3a4a5;
    }

    &__underline {
      position: relative;

      &:after {
        content:' ';
        position: absolute;
        top:120%;
        left:50%;
        width: 8rem;
        border:2px solid #30b5bb;
        border-radius:4px;
        transform:translateX(-50%);
      }
    }
  }
}
</style>
